import script from "./record-upload.vue?vue&type=script&setup=true&lang=js"
export * from "./record-upload.vue?vue&type=script&setup=true&lang=js"

import "./record-upload.vue?vue&type=style&index=0&id=3a9b011c&lang=scss"

const __exports__ = script;

export default __exports__